import { createGlobalStyle } from 'styled-components';
import 'antd/dist/antd.css';
import 'react-toastify/dist/ReactToastify.css';

export default createGlobalStyle`
  #root {
    height: 100%;
  }



  html, body {
    padding: 0;
    margin: 0;
    border: 0;
    box-sizing: border-box;
  }

  .table-row-light {
    background-color: #ffffff;
  }

  .table-row-dark {
    background-color: #fbfbfb;
  }

  .ui-datepicker{z-index: 2000!important}

.modal-splash {
  .ant-modal-content {
    background: transparent;
    border-radius: 0;
    box-shadow: none;
  }

  .ant-modal-body { padding: 0; }

  .ant-modal-close {
    top: 12px; right: 12px;
    width: 36px; height: 36px;
    border-radius: 50%;
    background: rgba(0, 0, 0, 0.45);
    display: flex; align-items: center; justify-content: center;
    backdrop-filter: blur(6px);
    transition: all 0.2s ease;

    &:hover {
      background: rgba(0, 0, 0, 0.65);
      transform: scale(1.05);
    }
  }

  .ant-modal-close-x { color: #fff; font-size: 16px; }
}
`;
